import React from "react";
import { HStack, Text, Tooltip } from "@chakra-ui/react";
import { REPORTING_YEARS } from "../suppliersMock";

const STATUS_META = {
  finalised:  { dot: "status.green",  label: "Finalised",   outline: false },
  inProgress: { dot: "status.orange", label: "In progress", outline: false },
  started:    { dot: "blue.300",      label: "Started",     outline: false },
  notStarted: { dot: "",              label: "Not started", outline: true  },
};

export function ReportingYearDot({ supplier, year, showYear = false }) {
  const status = supplier.yearStatus?.[year] ?? "notStarted";
  const { dot, label, outline } = STATUS_META[status] ?? STATUS_META.notStarted;

  return (
    <Tooltip label={`${year}: ${label}`} hasArrow placement="top">
      <HStack spacing={1.5} cursor="default" justify="center">
        {showYear && <Text fontSize="11px" color="gray.500" fontWeight="600">{year}</Text>}
        <Text
          w="9px"
          h="9px"
          borderRadius="full"
          flexShrink={0}
          bg={outline ? "transparent" : dot}
          border={outline ? "1.5px solid" : "none"}
          borderColor={outline ? "gray.300" : undefined}
        />
      </HStack>
    </Tooltip>
  );
}

// Inline row of per-year dots (current + previous two), used on the card where
// there's no column header to label the years — so each dot shows its year.
function ReportingYearStatus({ supplier }) {
  return (
    <HStack spacing={4}>
      {REPORTING_YEARS.map((year) => (
        <ReportingYearDot key={year} supplier={supplier} year={year} showYear />
      ))}
    </HStack>
  );
}

export default ReportingYearStatus;
